export const getDiscordUrlUtils = (emailEncrypted: string): string => {
	const href = window.config.Variables.DiscordUrl?.replace('{email}', emailEncrypted) ?? '';
	return href;
};